import React, { useState } from 'react';

interface Article {
  id: number;
  title: string;
  description: string;
  url: string;
  published_at: string;
  positivity: number;
  image_url: string;
}

interface ArticleListProps {
  articles: Article[];
}

const positivityHints = [
  'Velmi negativní',
  'Silně negativní',
  'Negativní',
  'Mírně negativní',
  'Spíše negativní',
  'Neutrální',
  'Spíše pozitivní',
  'Mírně pozitivní',
  'Pozitivní',
  'Silně pozitivní',
  'Velmi pozitivní'
];

const ArticleItem: React.FC<{ article: Article }> = ({ article }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const publishedDate = new Date(article.published_at + 'Z'); // Ensure the timestamp is treated as UTC
  const localPublishedAt = publishedDate.toLocaleString('cs-CZ', {
    hour: 'numeric',
    minute: 'numeric',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });

  return (
    <div key={article.id} className={`article ${imageLoaded ? 'loaded' : ''}`}>
      <div className="article-header">
        {article.image_url && (
          <img
            src={article.image_url}
            alt={article.title}
            className="article-image"
            onLoad={() => setImageLoaded(true)}
          />
        )}
        <div className="article-content">
          <a href={article.url} target="_blank" rel="noopener noreferrer">
            <h3>{article.title}</h3>
          </a>
          {/* Positivity bar */}
          <div className="positivity-bar" title={positivityHints[article.positivity]}>
            <div className="positivity-gradient"></div>
            <div className="positivity-marker" style={{ left: `${(article.positivity / 10) * 100}%` }}></div>
          </div>
          <p className="article-meta">
            {localPublishedAt} {new URL(article.url).hostname}
          </p>
        </div>
      </div>
      <p className="article-description">
        {article.description}
        <span className="fade-out"></span>
      </p>
    </div>
  );
};

const ArticleList: React.FC<ArticleListProps> = ({ articles }) => {
  const placeholders = Array(5).fill(null);

  return (
    <>
      {(articles && articles.length > 0 ? articles : placeholders).map((article, index) => {
        if (article) {
          return <ArticleItem key={article.id} article={article} />;
        } else {
          // Render placeholder
          return (
            <div key={index} className="article placeholder">
              <div className="article-header">
                <div className="article-image-placeholder"></div>
                <div className="article-content">
                  <div className="article-title-placeholder"></div>
                  <div className="positivity-bar-placeholder"></div>
                  <div className="article-meta-placeholder"></div>
                </div>
              </div>
              <div className="article-description-placeholder"></div>
            </div>
          );
        }
      })}
    </>
  );
};

export default ArticleList;
